import { iconSwitchTransition as e } from "../../../../_styles/transitions/icon-switch.cssr.js";
import { c as o, cB as r, cE as t } from "../../../../_utils/cssr/index.js";
const n = o([o("@keyframes rotator", `
 0% {
 -webkit-transform: rotate(0deg);
 transform: rotate(0deg);
 }
 100% {
 -webkit-transform: rotate(360deg);
 transform: rotate(360deg);
 }`), r("base-loading", `
 position: relative;
 line-height: 0;
 width: 1em;
 height: 1em;
 `, [t("transition-wrapper", `
 position: absolute;
 width: 100%;
 height: 100%;
 `, [e()]), t("placeholder", `
 position: absolute;
 left: 50%;
 top: 50%;
 transform: translateX(-50%) translateY(-50%);
 `, [e({
  left: "50%",
  top: "50%",
  originalTransform: "translateX(-50%) translateY(-50%)"
})]), t("container", `
 animation: rotator 3s linear infinite both;
 `, [t("icon", `
 height: 1em;
 width: 1em;
 `)])])]);
export {
  n as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_internal/loading/src/styles/index.cssr.js
// module id = 1604
// module chunks = 67